/* src/app/modules/invoice/tickets/ticket.component.css */
.fi-dialog-header {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem 0.75rem !important;
  margin: 0 !important;
  border-bottom: 1px solid #f0f0f0;
}
.fi-dialog-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: #1f2937;
}
.fi-dialog-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}
.fi-dialog-icon mat-icon {
  color: #e3fd64;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.fi-close-btn {
  color: #9ca3af;
}
.fi-content {
  padding: 1.25rem 1.25rem 0.5rem !important;
  max-height: 70vh;
}
.fi-prefix-icon,
.fi-suffix-icon {
  font-size: 18px;
  color: #9ca3af;
}
.fi-taxes-section {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  background: #fafafa;
}
.fi-taxes-label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.6rem;
}
.fi-taxes-label mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #9ca3af;
}
.fi-chips-wrap {
  margin-top: 0.5rem;
}
.fi-total-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background:
    linear-gradient(
      135deg,
      #fff8e6 0%,
      #fff3d6 100%);
  border: 1px solid #e3fd64;
  border-radius: 8px;
  padding: 0.75rem 1.25rem;
}
.fi-total-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #92400e;
}
.fi-total-value {
  font-size: 1.3rem;
  font-weight: 700;
  color: #92400e;
  letter-spacing: -0.01em;
}
.fi-actions {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem 1rem !important;
  border-top: 1px solid #f0f0f0;
}
.fi-action-secondary {
  color: #6b7280;
}
.fi-actions-right {
  display: flex;
  gap: 0.5rem;
}
@media (max-width: 560px) {
  .fi-content {
    min-width: unset;
    padding: 1rem !important;
  }
}
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
.conceptsList {
  height: 300px;
  overflow-x: auto;
  padding-right: 5px;
}
table thead tr {
  background: #e3fd64;
}
tfoot {
  background-color: #343a40;
  color: white;
}
:host ::ng-deep .tf-field {
  width: 100% !important;
}
.tf-form {
  padding-bottom: 2rem;
}
.tf-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0 1.25rem;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 1.5rem;
}
.tf-page-title {
  font-weight: 700;
  font-size: 1.4rem;
  color: #1f2937;
  margin: 0;
}
.tf-card mat-card-content {
  padding: 1.25rem !important;
}
.tf-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
}
.tf-section-title {
  font-weight: 600;
  font-size: 1rem;
  color: #1f2937;
  margin: 0;
}
.tf-section-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.tf-checkbox-field {
  display: flex;
  align-items: center;
  min-height: 56px;
}
.tf-lines-wrap {
  overflow-x: auto;
}
.tf-line {
  display: grid;
  grid-template-columns: 3fr 55px 90px 65px 2fr 105px 88px;
  align-items: center;
  column-gap: 0.5rem;
  padding: 0.4rem 0.75rem;
}
.tf-line--header {
  background: #f8f9fa;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 0.5rem;
}
.tf-line--data {
  background: #fff;
  transition: box-shadow 0.15s ease;
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
  margin-bottom: 0.35rem;
}
.tf-line--data:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.tf-cell-label {
  display: none;
  font-size: 0.72rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: .03em;
}
.tf-line-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0;
}
@media (max-width: 767px) {
  .tf-line--header {
    display: none;
  }
  .tf-line--data {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    padding: 0.75rem 1rem;
  }
  .tf-line--data .tf-cell {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    font-size: 0.9rem;
  }
  .tf-cell-label {
    display: inline;
  }
  .tf-line-actions {
    justify-content: flex-end;
    margin-top: 0.25rem;
  }
}
.tf-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1rem;
  color: #9ca3af;
}
.tf-empty-state mat-icon {
  font-size: 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  margin-bottom: 0.5rem;
  opacity: 0.4;
}
.tf-empty-state p {
  margin: 0;
  font-size: 0.9rem;
}
.tf-summary {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  background: #fafafa;
}
.tf-summary-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #374151;
  padding: 4px 0;
}
.tf-summary-divider {
  border-top: 1px solid #e5e7eb;
  margin: 0.5rem 0;
}
.tf-summary-row--total {
  font-weight: 700;
  font-size: 15px;
  color: #111827;
}
.tf-summary-row--total span:last-child {
  font-size: 16px;
}
.pf-totals-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 0.25rem;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.pf-totals-bar__items {
  display: flex;
  align-items: center;
  gap: 0.25rem 0.75rem;
  flex-wrap: wrap;
  color: #6b7280;
  font-size: 0.88rem;
}
.pf-totals-bar__item strong {
  color: #374151;
  font-weight: 600;
}
.pf-totals-bar__sep {
  color: #d1d5db;
}
.pf-totals-bar__total {
  font-size: 0.9rem;
  color: #6b7280;
  white-space: nowrap;
}
.pf-totals-bar__total strong {
  font-size: 1.2rem;
  font-weight: 700;
  color: #111827;
  margin-left: 0.25rem;
}
.pf-section-divider {
  border-top: 1px solid #f0f0f0;
  margin-bottom: 0.75rem;
}
.summary-row.total span:last-child {
  font-size: 16px;
}
/*# sourceMappingURL=ticket.component.css.map */
